import dynamic from 'next/dynamic'
import type { ReactElement } from 'react'

type ClientOnlyProps = { children: ReactElement }
const ClientOnly = (props: ClientOnlyProps) => {
  const { children } = props;

  return children;
};

export default dynamic(() => Promise.resolve(ClientOnly), {
  ssr: false,
});
